import React, { useState, useEffect } from 'react';
import { HashRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Landing from './pages/Landing';
import QuickStart from './pages/QuickStart';
import ApiRef from './pages/ApiRef';
import StdLib from './pages/StdLib';

function AppInner() {
  const [theme, setTheme] = useState(() => localStorage.getItem('celest-theme') || 'light');
  const loc = useLocation();

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme === 'dark' ? 'dark' : 'light');
    localStorage.setItem('celest-theme', theme);
  }, [theme]);

  const isHome = loc.pathname === '/' || loc.hash === '#/' || loc.hash === '';

  return (
    <div>
      <Navbar theme={theme} setTheme={setTheme} />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/quickstart" element={<QuickStart />} />
        <Route path="/api" element={<ApiRef />} />
        <Route path="/stdlib" element={<StdLib />} />
      </Routes>
      {!isHome && (
        <footer>celest v1.0.0</footer>
      )}
    </div>
  );
}

export default function App() {
  return (
    <HashRouter>
      <AppInner />
    </HashRouter>
  );
}